var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 3.5,
    fill: "white",
    stroke: "#CCCCCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 17C17.55 17 18.0208 16.8042 18.4125 16.4125C18.8042 16.0208 19 15.55 19 15C19 14.45 18.8042 13.9792 18.4125 13.5875C18.0208 13.1958 17.55 13 17 13C16.45 13 15.9792 13.1958 15.5875 13.5875C15.1958 13.9792 15 14.45 15 15C15 15.55 15.1958 16.0208 15.5875 16.4125C15.9792 16.8042 16.45 17 17 17ZM17 24.35C19.0333 22.4833 20.5417 20.7875 21.525 19.2625C22.5083 17.7375 23 16.3833 23 15.2C23 13.3833 22.4208 11.8958 21.2625 10.7375C20.1042 9.57917 18.6833 9 17 9C15.3167 9 13.8958 9.57917 12.7375 10.7375C11.5792 11.8958 11 13.3833 11 15.2C11 16.3833 11.4917 17.7375 12.475 19.2625C13.4583 20.7875 14.9667 22.4833 17 24.35ZM17 27C14.3167 24.7167 12.3125 22.5958 10.9875 20.6375C9.6625 18.6792 9 16.8667 9 15.2C9 12.7 9.80417 10.7083 11.4125 9.225C13.0208 7.74167 14.8833 7 17 7C19.1167 7 20.9792 7.74167 22.5875 9.225C24.1958 10.7083 25 12.7 25 15.2C25 16.8667 24.3375 18.6792 23.0125 20.6375C21.6875 22.5958 19.6833 24.7167 17 27Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactLocation);
export default __webpack_public_path__ + "static/media/contactLocation.9889040e665044aedd138912a9573a77.svg";
export { ForwardRef as ReactComponent };